import "antd/lib/card/style";
import _Card from "antd/lib/card";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import "antd/lib/icon/style";
import _Icon from "antd/lib/icon";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/select/style";
import _Select from "antd/lib/select";
import "antd/lib/form/style";
import _Form from "antd/lib/form"; /*@通用页面-忘记密码*/
import React from 'react';
import { injectIntl } from "react-intl";
import localeList from "../../../locales/_localeList";
import { domain } from "../../../utils/commonConsts";
import loginbg from '../../../assets/img/loginbg.png';
var FormItem = _Form.Item;
var Option = _Select.Option;
var RememberPassword = /*#__PURE__*/function (_React$Component) {
  _inherits(RememberPassword, _React$Component);
  function RememberPassword(props) {
    var _this;
    _classCallCheck(this, RememberPassword);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(RememberPassword).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_logoPic", function () {
      _this.props.dispatch({
        type: "indexPage/get_logoPic",
        payload: {
          url: window.location.protocol + "//" + window.location.hostname,
          logo_type: 'bck'
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getCaptcha", function () {
      _this.props.dispatch({
        type: "rememberPassword/getCaptcha",
        payload: {}
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSubmit", function () {
      _this.props.form.validateFields(function (err, values) {
        if (!err) {
          _this.props.dispatch({
            type: "rememberPassword/resend_password",
            payload: {
              email: values.email.replace(/(^\s*)|(\s*$)/g, ""),
              captcha_code: values.captcha
            }
          });
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSelectLanguage", function (value) {
      window.location.href = domain + '/index.' + value + '.html#' + _this.props.location.pathname + _this.props.location.search;
    });
    _this.state = {};
    return _this;
  }
  _createClass(RememberPassword, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.get_logoPic();
      this.getCaptcha();
    }
  }, {
    key: "render",
    value: function render() {
      var getFieldDecorator = this.props.form.getFieldDecorator;
      var inEnglish = window.appLocale.locale === "en-US";
      return /*#__PURE__*/React.createElement("div", {
        className: "loginMainContainer"
      }, /*#__PURE__*/React.createElement("header", {
        className: "headerContainer"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "inline-block",
          "float": "right"
        }
      }, /*#__PURE__*/React.createElement(_Icon, {
        type: "global",
        style: {
          fontSize: 16,
          marginRight: 8,
          marginTop: 20
        }
      }), /*#__PURE__*/React.createElement(_Select, {
        style: {
          width: 100,
          marginRight: 16,
          clear: 'both'
        },
        onChange: this.handleSelectLanguage,
        value: window.appLocale.locale
      }, localeList.map(function (lang) {
        return /*#__PURE__*/React.createElement(Option, {
          value: lang.name,
          key: lang.name
        }, lang.label);
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "dash"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 24
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "loginContainer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "loginbg"
      }, this.props.indexPage.logo_pic ? /*#__PURE__*/React.createElement("img", {
        src: this.props.indexPage.logo_pic === "default" ? loginbg : domain + this.props.indexPage.logo_pic,
        alt: "loginbg"
      }) : /*#__PURE__*/React.createElement("img", {
        src: loginbg,
        alt: "loginbg"
      })), /*#__PURE__*/React.createElement(_Card, {
        bordered: false,
        className: "logincon"
      }, /*#__PURE__*/React.createElement("a", {
        href: domain + '/index.' + window.appLocale.locale + '.html#'
      }, '<', "\xA0", "Return to login"), /*#__PURE__*/React.createElement("div", {
        className: "title",
        style: inEnglish ? {
          fontSize: 20
        } : {}
      }, "Retrieve password"), /*#__PURE__*/React.createElement(_Form, {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/React.createElement(FormItem, {
        className: "FormItem"
      }, getFieldDecorator('email', {
        rules: [{
          required: true,
          message: "Please enter your email address"
        }]
      })(/*#__PURE__*/React.createElement(_Input, {
        size: "large",
        placeholder: "Please enter your email address",
        className: "input"
      }))), /*#__PURE__*/React.createElement(FormItem, {
        className: "FormItem"
      }, getFieldDecorator('captcha', {
        rules: [{
          required: true,
          message: "Please enter the verification code"
        }]
      })(/*#__PURE__*/React.createElement(_Input, {
        size: "large",
        style: {
          width: 150
        },
        placeholder: "Please enter the verification code",
        className: "input"
      })), /*#__PURE__*/React.createElement("img", {
        src: this.props.rememberPassword.captchaUrl,
        alt: "",
        style: {
          width: 60,
          height: 40,
          marginLeft: 58
        }
      }), /*#__PURE__*/React.createElement(_Icon, {
        type: "reload",
        style: {
          fontSize: 16,
          marginLeft: 12
        },
        onClick: this.getCaptcha
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: "left",
          color: 'rgba(0,0,0,0.65)',
          marginTop: '-11px'
        }
      }, /*#__PURE__*/React.createElement("span", null, "The new password will be sent to your email, please check it promptly")), /*#__PURE__*/React.createElement(_Button, {
        style: {
          marginTop: 20
        },
        type: "primary",
        htmlType: "submit",
        className: "confirmBtn"
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: "#fff"
        }
      }, "Verify Now")))))));
    }
  }]);
  return RememberPassword;
}(React.Component);
export default injectIntl(RememberPassword);